import { render, staticRenderFns } from "./PcNoticeName.vue?vue&type=template&id=7a1dd9a1"
import script from "./PcNoticeName.vue?vue&type=script&lang=js"
export * from "./PcNoticeName.vue?vue&type=script&lang=js"
import style0 from "./PcNoticeName.vue?vue&type=style&index=0&id=7a1dd9a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports